import React from "react";
import { Modal } from "reactstrap";

import MetaList from "components/Admin/MetaList";
import { COLLECTED, NEVER_COLLECTED, PENDING, collectionState, passCount, passLines } from "utils/passes";

/**
 * What is being handed over, and the two ways an order leaves the queue.
 *
 * Only pass lines reach here — the server strips sponsorships, because there is nothing to collect
 * for a Dhaki or a Purohit. "Never collected" is the honest exit for somebody who did not turn up:
 * it clears the row without claiming the passes were given out, and sends no mail.
 */
function PassCollectModal({ order, busy, viewOnly, onClose, onSetState }) {
  if (order == null) return null;

  const state = collectionState(order);
  const lines = passLines(order);
  const total = passCount(order);

  const actions = [];
  if (state !== COLLECTED) {
    actions.push({ key: COLLECTED, label: "Mark collected", className: "hm-btn hm-btn-primary" });
  }
  if (state === PENDING) {
    actions.push({ key: NEVER_COLLECTED, label: "Never collected", className: "hm-btn hm-btn-outline" });
  }
  if (state !== PENDING) {
    actions.push({ key: PENDING, label: "Move back to pending", className: "hm-btn hm-btn-outline" });
  }

  return (
    <Modal isOpen={true} size="lg" centered scrollable contentClassName="hm-modal">
      <div className="hm-modal-head">
        <div>
          <span className="hm-modal-eyebrow">Passes</span>
          <h5 className="hm-modal-title">{order.userName}</h5>
        </div>
        <button aria-label="Close" className="hm-modal-x" type="button" onClick={onClose}>
          <span aria-hidden={true}>×</span>
        </button>
      </div>

      <div className="hm-modal-body">
        <div className="hm-tbl-wrap">
          <table className="hm-tbl">
            <thead>
              <tr>
                <th className="is-name">Pass</th>
                <th className="is-num">Qty</th>
              </tr>
            </thead>
            <tbody>
              {lines.map((line) => (
                <tr key={line.code}>
                  <td className="is-name">{line.name}</td>
                  <td className="is-num">{line.qty}</td>
                </tr>
              ))}
              <tr className="hm-pass-total">
                <td className="is-name">Total to hand over</td>
                <td className="is-num">{total}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <MetaList
          rows={[
            ["Contribution ID", order.orderRcptId],
            ["Order date", order.orderDate],
            ["Email", order.userEmail],
            ["Mobile", order.userMobile],
          ]}
        />

        {state === PENDING && (
          <p className="hm-pass-note">
            Marking never collected clears this from the queue without emailing the contributor. It
            can be moved back at any time.
          </p>
        )}
      </div>

      <div className="hm-modal-foot">
        <button className="hm-btn hm-btn-outline" type="button" onClick={onClose}>
          Cancel
        </button>
        {actions.map((action) => (
          <button
            key={action.key}
            className={action.className}
            type="button"
            disabled={viewOnly || busy}
            onClick={() => onSetState(order, action.key)}
          >
            {action.label}
          </button>
        ))}
      </div>
    </Modal>
  );
}

export default PassCollectModal;
